export default __webpack_public_path__ + "static/media/about-ywly-icon5.77b64f52.png";